import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=bb9d99fa&scoped=true&"
import script from "./Secure.vue?vue&type=script&lang=js&"
export * from "./Secure.vue?vue&type=script&lang=js&"
import style0 from "./Secure.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Secure.vue?vue&type=style&index=1&id=bb9d99fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9d99fa",
  null
  
)

export default component.exports